import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AddressDataModel, AddressModel, DataViewEnum, ColumnModel } from '../models';
import { setFormattedData, addOrUpdateData } from '../helpers/helper';

export interface AddressesState {
  dataView: DataViewEnum;
  data: AddressDataModel;
}

const initialState: AddressesState = {
  dataView: DataViewEnum.List,

  data: {
    recordCount: 0,
    records: [],
    rawData: [],
    columns: []
  },
};

const uniqueDataKey = "addressId";
 // Remap address1 to addressLineOne

const columnConfig: Record<string, Partial<ColumnModel>> = {
  primaryKeyId: {
      width: 60,
      formatter: (record: AddressModel) => record.addressId
  },
  locationName: { width: 200 },
  addressLineOne: { width: 200, formatter: (record: AddressModel)  => record.address1 },
  addressLineTwo: { width: 200, formatter: (record: AddressModel) => record.address2 },
  town: { width: 200 },
  county: { width: 200 },
  postCode: { width: 180 },
  email: { width: 200 }
};

export const addresssSlice = createSlice({
  name: 'addresss',
  initialState,
  reducers: {
    setDataView: (state, action: PayloadAction<DataViewEnum>) => {
      state.dataView = action.payload;
      return state;
    },
    setAddresssData: (state, action: PayloadAction<AddressModel[]>) => {
      state.data = setFormattedData({ rawData: action.payload }, columnConfig, uniqueDataKey);
    },
    setAddress: (state, action: PayloadAction<AddressModel>) => {
      addOrUpdateData(state.data, action.payload, columnConfig, uniqueDataKey);
      return state;
    },
    removeAddress: (state, action: PayloadAction<number>) => {
      state.data.records = state.data.records.filter(record => record[uniqueDataKey] !== action.payload);
      state.data.rawData = state.data.rawData.filter(raw => raw[uniqueDataKey] !== action.payload);
      return state
    },
    setLogoutAddresss: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { setDataView, setAddresssData, setAddress, removeAddress, setLogoutAddresss } = addresssSlice.actions;

export default addresssSlice.reducer;
